export const KEY = 'lib_beneficiary'
